(function () {
  document.querySelectorAll('[data-ic-legacy-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-ic-legacy-track]');
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-ic-legacy-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-ic-legacy-dot]'));
    var previous = slider.querySelector('[data-ic-legacy-previous]');
    var next = slider.querySelector('[data-ic-legacy-next]');
    var activeIndex = 0;

    if (!track || slides.length < 2) return;

    function setActive(index) {
      activeIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: 'smooth' });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    if (previous) previous.addEventListener('click', function () { setActive(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { setActive(activeIndex + 1); });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { setActive(index); });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== activeIndex && index >= 0 && index < slides.length) {
          activeIndex = index;
          dots.forEach(function (dot, dotIndex) {
            var active = dotIndex === activeIndex;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        }
      });
    }, { passive: true });
  });
})();
